import React, { useEffect, useState } from 'react';
import { Badge, Button, Form, Input, message, Spin } from "antd";
import { InfoCircleOutlined } from '@ant-design/icons';

import { VERSION_TICK } from '../../config/media';
import { checkRequired, checkURL } from '../../common/utils';
import { putExchange } from '../../common/fetch';

import { Rive } from '../RiveComponent';
import { SetupWrapper } from './style';

const { Item } = Form;


const RenderSetup = (props) => {

    const { updateWidth, onCancel, exchange, handleCloud } = props;
    const { getFieldDecorator, validateFields, getFieldValue } = props.form;

    const [popupText, setPopupText] = useState('setup-email');
    const [formValues, setFormValues] = useState({ domain: "hollaex.net" });
    const [isMainEmailDomain, setIsMainEmailDomain] = useState(false);
    const [isChecked, setIsChecked] = useState(false);
    const [DNSsetupData, setDNSsetupData] = useState({ verification: [], verified: false });
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (popupText === 'setup-email' || popupText === "setup-complete-stage1") {
            updateWidth('33rem');
        } else if (popupText === 'main-email-domain') {
            updateWidth("50rem");
        }
        if (popupText === "setup-complete-stage2") {
            localStorage.removeItem("SETUPCOMPLETE");
        }
        // eslint-disable-next-line
    }, [popupText])

    const handleEvent = () => {
        props.history.push('/hosting?tab=4');
        setTimeout(() => {
            localStorage.setItem("SETUPCOMPLETE", true);
            onCancel();
        }, 35000)
    }

    const handleNext = (domain) => {
        setFormValues({ domain })
        handleDomainCheck('Setup email', domain);
        setIsChecked(false);
    }

    const handleDomainCheck = async (params = "", domain) => {
        setIsLoading(true);
        try {
            const { id } = exchange || {};
            const data = {
                id,
                smtp: { domain }
            };
            let res = await putExchange(data);
            if (res.data) {
                setDNSsetupData(res.data.smtp);
                setIsLoading(false);
                setPopupText("DNS-setup");
            }
        } catch (err) {
            setIsLoading(false);
            if (err && err.data) {
                message.error(err.data.message);
            }
            setIsMainEmailDomain(true);
        }
        if (params === "checked") {
            setIsMainEmailDomain(true);
            setIsChecked(true);
        }
    }

    const checkDot = (rule, value, callback) => {
        if (value.length && !value.includes('.')) {
            callback('The format of domain is wrong. e.g. domain.com');
        } else {
            callback();
        }
    };

    const copyToClipboard = (fieldId) => {
        var range = document.createRange();
        range.selectNode(document.getElementById(fieldId));
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(range);
        document.execCommand("copy");
        window.getSelection().removeAllRanges();
        message.success('Copied!');
    }

    const handleSetupEmail = () => {
        setPopupText("setup-complete-stage1");
        handleCloud('setEmail');
        localStorage.removeItem('CURRENTOBJECT');
        localStorage.setItem("isEventStart", true);
    }

    const renderCondent = () => {
        switch (popupText) {
            case 'setup-complete-stage1':
                return (
                    <div >
                        <div className='events-email-animation'>
                            <Rive src={'updateEmail.riv'} />
                        </div>
                        <div className='container'>
                            <div className="title">Email setup complete!</div>
                            <div className='margin-05'>Your automated email setup is complete. It will take about 3 minutes on average to apply.</div>
                            <div className='text-container'>You can monitor the status on the Events page.</div>
                            <div className="setup-btn-container">
                                <Button type="primary" onClick={handleEvent}>
                                    Go to events
                                </Button>
                            </div>
                        </div>
                    </div>
                )
            case 'DNS-setup':
                return (
                    <Spin spinning={isLoading}>
                        <div className="container">
                            <div className='header'>Setup email</div>
                            <div className="title">
                                Email DNS setup
                            </div>
                            <div>
                                Add the following configuration in your DNS provider:
                            </div>
                            <div className="input-wrapper">
                                {DNSsetupData.verification.map((item, index) => {
                                    return (
                                        <div className='box-content'>
                                            <div className="box-container" key={index}>
                                                <div className="first-column">
                                                    <div className='value-container' id={`name_${index}`}>{item.name}</div>
                                                    <div className='column-container' onClick={() => copyToClipboard(`name_${index}`)}>COPY</div>
                                                </div>
                                                <div className="second-column">
                                                    {item.record_type}
                                                </div>
                                                <div className="third-column">
                                                    <div className='value-container' id={`value_${index}`} >{item.value}</div>
                                                    <div className='column-container' onClick={() => copyToClipboard(`value_${index}`)}>COPY</div>
                                                </div>
                                            </div>
                                            <div className='icon-container'>
                                                {isChecked && isMainEmailDomain
                                                    ? item.valid === "valid" || DNSsetupData.verified === true ?
                                                        <img src={VERSION_TICK} alt="tick" className="content-icon" />
                                                        : <div className='circle-minus'>&#8722;</div>
                                                    : null
                                                }
                                            </div>
                                        </div>
                                    )
                                })}
                                <div className="chk-btn-container">
                                    <Button
                                        type="primary"
                                        onClick={() => handleDomainCheck('checked', formValues.domain)}
                                        disabled={isMainEmailDomain && DNSsetupData.verified}
                                    >
                                        Check
                                    </Button>
                                    <div className='anchor'>Need help? Visit the{' '}
                                        <a
                                            href="https://forum.hollaex.com/search?q=domain"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            forums.
                                        </a>
                                    </div>
                                </div>
                                {isChecked && isMainEmailDomain
                                    ? DNSsetupData.verified === true
                                        ? (<div className="status success-status">
                                            <Badge
                                                text="We see it! Proceed by clicking next."
                                                status="success"
                                            >
                                            </Badge>
                                        </div>)
                                        : (<div className="status error-status">
                                            <Badge
                                                text="Records are not set correctly"
                                                status="error"
                                            >
                                            </Badge>
                                        </div>)
                                    : null
                                }
                            </div>
                            <div className="btn-container">
                                <Button
                                    type="primary"
                                    onClick={() => setPopupText("main-email-domain")}
                                >
                                    Back
                                </Button>
                                <div className="separator"></div>
                                <Button
                                    type="primary"
                                    onClick={() => handleSetupEmail()}
                                    disabled={!isMainEmailDomain || !DNSsetupData.verified}
                                >
                                    Next
                                </Button>
                            </div>
                        </div>
                    </Spin>
                )
            case 'main-email-domain':
                return (
                    <Spin spinning={isLoading}>
                        <div className="container">
                            <div className='header'>Setup email</div>
                            <div className="title">
                                Main email domain
                            </div>
                            <div>
                                Enter the domain name you would like to use with your exchange.
                            </div>
                            <Form
                                onSubmit={(e) => {
                                    e.preventDefault();
                                    validateFields((err, values) => {
                                        if (!err) {
                                            handleNext(values.domain);
                                        }
                                    });
                                }}
                            >
                                <div className="input-wrapper custom-input">
                                    <span className='special-char'>@</span>
                                    <Item className='setup-domain-input-container'>
                                        {
                                            getFieldDecorator('domain', {
                                                rules: [
                                                    {
                                                        validator: checkRequired
                                                    },
                                                    {
                                                        validator: checkURL
                                                    },
                                                    {
                                                        validator: checkDot
                                                    },
                                                ],
                                            })(
                                                <Input
                                                    placeholder="myexchange.com"
                                                />
                                            )}
                                    </Item>
                                </div>
                                <div className='anchor'>Need help? Visit the{' '}
                                    <a
                                        href="https://forum.hollaex.com/search?q=domain"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        forums.
                                    </a>
                                </div>
                                <div className="btn-container">
                                    <Button
                                        type="primary"
                                        onClick={() => setPopupText("setup-email")}
                                    >
                                        Back
                                    </Button>
                                    <div className="separator"></div>
                                    <Button
                                        type="primary"
                                        htmlType={'submit'}
                                        disabled={!getFieldValue('domain')}
                                    >
                                        Next
                                    </Button>
                                </div>
                            </Form>
                        </div>
                    </Spin>
                )
            default:
            case "setup-email":
                return (
                    <div className='mail-container'>
                        <div className='icon-container'><InfoCircleOutlined /></div>
                        <div className='title'>Setup Email</div>
                        <div className='para-container'>Setting up an email system will allow important functions like fund withdrawal confirmations and user email sign up verification to be sent to your user's email. While you can setup your own SMTP system in your exchange itself directly, alternatively by clicking next below you agree to use HollaEx's built in emailing system for your ecxchange. Please avoid using this feature if you have already setup an SMTP mail system on your exchange.</div>
                        <div className='text-container'>Do you want to proceed?</div>
                        <div className="btn-container">
                            <Button
                                type="primary"
                                onClick={() => onCancel()}
                            >
                                Back
                            </Button>
                            <Button
                                type="primary"
                                onClick={() => setPopupText('main-email-domain')}
                            >
                                Next
                            </Button>
                        </div>
                    </div>
                )
        }
    }
    return (
        <SetupWrapper>
            {renderCondent()}
        </SetupWrapper>
    )
}
const RenderSetupContent = Form.create({ name: 'RenderSetup' })(RenderSetup);
export default RenderSetupContent;